import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "home-product-card" }
const _hoisted_2 = {
  key: 0,
  class: "home-product-card__media"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 0,
  class: "home-product-card__date"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = {
  key: 0,
  class: "home-product-card__thumb-more"
}
const _hoisted_8 = { class: "home-product-card__header" }
const _hoisted_9 = { class: "home-product-card__name" }
const _hoisted_10 = {
  key: 0,
  class: "home-product-card__subname"
}
const _hoisted_11 = {
  key: 1,
  class: "home-product-card__info-wrap"
}
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 2,
  class: "product-card-footer home-product-card__footer"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ImageGalleryModal = _resolveComponent("ImageGalleryModal")

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    (_ctx.product.images.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["home-product-card__media-row", { 'home-product-card__media-row--has-thumbs': _ctx.thumbSlots.length }])
          }, [
            _createElementVNode("button", {
              type: "button",
              class: "home-product-card__hero",
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.openGallery(0)))
            }, [
              _createElementVNode("img", {
                src: _ctx.product.images[0],
                alt: _ctx.product.name,
                class: "home-product-card__hero-img"
              }, null, 8 /* PROPS */, _hoisted_3),
              (_ctx.formattedDate)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                    _cache[3] || (_cache[3] = _createElementVNode("svg", {
                      class: "home-product-card__date-icon",
                      viewBox: "0 0 24 24",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("path", {
                        fill: "currentColor",
                        d: "M7 2a1 1 0 0 1 1 1v1h8V3a1 1 0 1 1 2 0v1h1.5A2.5 2.5 0 0 1 22 6.5v13A2.5 2.5 0 0 1 19.5 22h-15A2.5 2.5 0 0 1 2 19.5v-13A2.5 2.5 0 0 1 4.5 4H6V3a1 1 0 0 1 1-1Zm12.5 7H4.5v10.5c0 .276.224.5.5.5h15a.5.5 0 0 0 .5-.5V9ZM6 6h-.5a.5.5 0 0 0-.5.5V7h14v-.5a.5.5 0 0 0-.5-.5H18v1a1 1 0 1 1-2 0V6H8v1a1 1 0 1 1-2 0V6Z"
                      })
                    ], -1 /* CACHED */)),
                    _createTextVNode(" " + _toDisplayString(_ctx.formattedDate), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            (_ctx.thumbSlots.length)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["home-product-card__thumbs", `home-product-card__thumbs--count-${Math.min(_ctx.thumbSlots.length, 3)}`])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thumbSlots, (slot) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: `${_ctx.product.id}-thumb-${slot.index}`,
                      type: "button",
                      class: "home-product-card__thumb",
                      onClick: $event => (_ctx.openGallery(slot.index))
                    }, [
                      _createElementVNode("img", {
                        src: slot.src,
                        alt: `${_ctx.product.name} image ${slot.index + 1}`
                      }, null, 8 /* PROPS */, _hoisted_6),
                      (slot.showMore)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, " +" + _toDisplayString(slot.moreCount), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ], 8 /* PROPS */, _hoisted_5))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.product.name), 1 /* TEXT */),
      (_ctx.product.subname)
        ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.product.subname), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    (_ctx.hasDescription)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", {
            ref: "descriptionEl",
            class: _normalizeClass(["home-product-card__info", { 'is-expanded': _ctx.descriptionExpanded }]),
            innerHTML: _ctx.product.description
          }, null, 10 /* CLASS, PROPS */, _hoisted_12),
          (_ctx.showReadMoreToggle)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "home-product-card__read-more",
                onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.toggleDescription && _ctx.toggleDescription(...args)))
              }, _toDisplayString(_ctx.descriptionExpanded ? '[ read less ]' : '[ read more ]'), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.hasFooterLinks)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          (_ctx.product.youtube_primary_link)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: _ctx.product.youtube_primary_link,
                target: "_blank",
                rel: "noopener noreferrer",
                class: "btn-youtube"
              }, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("img", {
                  src: "/wp-content/themes/rufousone/img/youtube-bttn-small.jpg",
                  alt: "Watch Review"
                }, null, -1 /* CACHED */)
              ]))], 8 /* PROPS */, _hoisted_14))
            : _createCommentVNode("v-if", true),
          (_ctx.hasAmazonLink)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: _ctx.product.amazon_url,
                target: "_blank",
                rel: "noopener noreferrer",
                class: "buy-now-btn"
              }, [...(_cache[5] || (_cache[5] = [
                _createElementVNode("img", {
                  src: "/wp-content/themes/rufousone/img/amazon-bttn.png",
                  alt: "Buy on Amazon"
                }, null, -1 /* CACHED */)
              ]))], 8 /* PROPS */, _hoisted_15))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_ImageGalleryModal, {
      "is-open": _ctx.modalOpen,
      images: _ctx.product.images,
      "start-index": _ctx.modalStartIndex,
      "product-name": _ctx.product.name,
      onClose: _cache[2] || (_cache[2] = $event => (_ctx.modalOpen = false))
    }, null, 8 /* PROPS */, ["is-open", "images", "start-index", "product-name"])
  ]))
}